import { CommonModule } from '@angular/common';
import { Component,  EventEmitter,  Input, Output } from '@angular/core';
import { ToggleTabComponent } from 'src/app/components/buttons/toggle-tab.component';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';

@Component({
    selector: 'enable-links',
    template: `
<toggle-tab [text]="'Enable links in ' + shareName" [toggled]="enabled" [readOnly]="readOnly" [borderless]="true" (toggle)="toggle.emit()"></toggle-tab>
<tip-text [type]="'tip'" [head]="'Important:'" [body]="tipMessage"></tip-text>
`,
    styles: [`
  :host { display: flex; align-items: center; }
  toggle-tab { display: flex; margin-right: 20px; }
  :host ::ng-deep toggle-tab .toggle-text { font-size: 14px; }
`],
    standalone: true,
    imports: [ToggleTabComponent, TipTextComponent, CommonModule],
})
export class EnableLinksComponent {
  @Input() enabled: boolean
  @Input() readOnly: boolean
  @Input() shareName: string = 'share'
  @Input() tipMessage = `Shared active links can be access by anyone with the links. If security is a concern only allow access to links via workforce`
  
  @Output() toggle: EventEmitter<void> = new EventEmitter()
}

